export enum PvAttachmentType {
  PANORAMA = 'panorama',
  PICTURE = 'picture',
  PDF = 'pdf',
  ATTRIBUTE = 'attribute',
}